class Registration {
	private regformContainer: HTMLElement;
	private offsetElement: HTMLElement;

	constructor() {
		this.regformContainer = document.querySelector(
			'#regform-container, .sidebar .psg-reg-form'
		);
		this.offsetElement = document.querySelector('.sticky-navigation');

		if (!this.regformContainer || this.regformContainer?.offsetHeight === 0) {
			return;
		}

		document
			.querySelectorAll('.wp-block-button__link[href^="/profile/registration"]')
			.forEach((item: HTMLAnchorElement) => {
				item.addEventListener('click', (event: MouseEvent) =>
					this.onRegistrationLinkClick(event)
				);
			});
	}

	private onRegistrationLinkClick(event: MouseEvent): void {
		if (window.innerWidth < 930) {
			event.preventDefault();

			const offset: number = this.offsetElement?.offsetHeight ?? 0;

			window.scrollTo({
				left: 0,
				top: this.regformContainer.offsetTop - offset,
				behavior: 'smooth',
			});
		}
	}
}

if (/complete|interactive|loaded/.test(document.readyState)) {
	new Registration();
} else {
	document.addEventListener('DOMContentLoaded', () => new Registration());
}
